import React, { useEffect } from "react";
import Aos from "aos";
import "aos/dist/aos.css";

interface TextHeaderProps {
  text: string;
}

const TextHeader: React.FC<TextHeaderProps> = ({ text }) => {
  useEffect(function () {
    Aos.init({ duration: 1000 });
  }, []);

  return (
    <div
      data-aos="fade-up"
      data-aos-duration="1000"
      data-aos-delay="200"
      data-aos-offset="20"
      className="flex items-center gap-2 md:gap-[22px] overflow-hidden h-fit"
    >
      <span className="bg-gradient-to-b from-[#F0D35A] to-[#FFFFFF00] rounded-md w-[10px] h-[45px] md:h-[72px]" />
      <h2
        className="text-goldGradient w-fit text-[28px]/[35px] md:text-[52px]/[65px] uppercase font-habibi"
        style={{
          paintOrder: "stroke fill",
          WebkitTextStroke: "1.2px #FCF6D1",
        }}
      >
        {text}
      </h2>
    </div>
  );
};

export default TextHeader;
